import {SettingsService} from "@/services/ApiService";

const Settings = {
  state: {
    settingsLoaded: false,
    general: {
      dashboard: {
        url: "",
        secret_key: "",
        exp: null,
        refresh_time: 15,
        number: null,
      },
      notifications: {
        stack: false,
        enable: true,
        updateSameType: true,
        renotify: true,
        success: true,
        info: true,
        error: true,
        warning: true,
      },
      sse: {
        pingAbsenceLimit: 10000,
        logSSEState: false,
      },
    },
    applications: {
      priceguard: {
        dataExpirationCycle: 30,
        removeExpiredDataAfter: 30,
        priceOldAfter: 30,
      },
      analytics: {
        useDigitsField: false,
        positionLogs: false,
      },
      pricewatcher: {
        keepPreviousTimeFrameData: false,
        dataAbsenceWarning: 120,
      },
    },
    user: {},
    applicationState: {
      analytics: {
        instances: [],
        mergedInstances: [],
        selectedInstance: null,
        showingExposureTable: true,
        showingSummaryFooter: false
      },
      priceguard: {
        mute: false,
        expiring: false,
        ignoredItems: [],
        sort: "Newest",
      },
      tradewatcher: {
        mute: false,
        navBarPin: false,
        denseGrid: false,
      },
      mute: false,
      dark: true,
    },
    consent: false,
  },
  mutations: {
    updateApplicationState(state, {section, innerSection, mutation}) {
      if (!section) {
        console.error(
            `Error occured trying to save the current application state! Section given: ${section}`
        );
        return
      }

      if (innerSection) {
        if (state.applicationState.hasOwnProperty(section) && state.applicationState[section].hasOwnProperty(innerSection)) {
          state.applicationState[section][innerSection] = JSON.parse(JSON.stringify(mutation));
        } else {
          state.applicationState[section] = {}
          state.applicationState[section][innerSection] = JSON.parse(JSON.stringify(mutation));
        }
      } else
        state.applicationState[section] = JSON.parse(JSON.stringify(mutation));

    },
    updateSettings(state, mutatedSettings) {
      // settingsLoaded used in app.vue to determinte if the settings were are loaded
      if (!state.settingsLoaded) {
        state.settingsLoaded = true;
      }
      if (mutatedSettings && mutatedSettings.consent && (mutatedSettings.consent === true)) {
        state.consent = true;
      }

      state.general = JSON.parse(JSON.stringify(mutatedSettings.general));
      state.applications = JSON.parse(
          JSON.stringify(mutatedSettings.applications)
      );
      state.user = JSON.parse(JSON.stringify(mutatedSettings.user));
      state.applicationState = JSON.parse(
          JSON.stringify(mutatedSettings.applicationState)
      );
      state.device = mutatedSettings.device;
    },
    updateSpecificSetting(state, setting) {
      if (setting.sections.length == 2) {
        state[setting.sections["0"]][setting.sections["1"]] = setting.value;
      } else {
        state[setting.sections["0"]][setting.sections["1"]][
            setting.sections["2"]
            ] = setting.value;
      }
    },
  },
  getters: {
    getSettings: (state) => {
      return state;
    },
    getSpecificSetting: (state) => (setting) => {
      return state[setting.section][setting.innerSection];
    },
    getHasConsented: (state) => {
      return state.consent;
    }
  },
  actions: {
    /**
     * Update the settings for the current account on the database
     *
     * @param settings {Object} - the settings data to update
     * @param recursive {Boolean}
     */
    updateAppSettingsRemotely({settings, recursive}) {
      // console.log('settings in update settings remotely store action', settings);
      let profileId = parseInt(
          localStorage.getItem("currentSettingsProfileId"),
          10
      );

      if (!profileId && profileId !== 0) {
        if (this.isAdmin)
          console.log(
              "No profile ID found when updating the application state."
          );
        return;
      }

      let requestStatus = "200";

      SettingsService.put(profileId, settings)
          .then(() => {
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1 &&
                !recursive
            ) {
              requestStatus = "404";
              // Get the configuration for the current type of device
              return SettingsService.getMe({
                params: {
                  device:
                      localStorage.getItem("selected-device-type") || "Desktop",
                },
              });
              // return SettingsService.getMe({ params: { device: "Desktop" } })
            }
          })
          .then((response) => {
            if (requestStatus === "404" && response.data && !recursive) {
              localStorage.setItem(
                  "currentSettingsProfileId",
                  response.data.id
              );

              this.updateAppSettingsRemotely({
                settings: settings,
                recursive: true,
              });
            }
          })
          .catch((error) => {
            if (
                error.hasOwnProperty("message") &&
                error.message.search("404") !== -1
            ) {
              this.postNewSetting(false, settings);
            }
          });
    },
  }
};
export default Settings;
